import gql from 'graphql-tag';

export const USER_OPPORTUNITY_CREATE_MANY = gql`
  mutation USER_OPPORTUNITY_CREATE_MANY($opportunities: [UserOpportunityInsertInput]!) {
    userOpportunityCreateMany(opportunities: $opportunities)
  }
`;
